module.exports = __webpack_public_path__ + "img/case_01.5b540521.jpg";